import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';
import { clsx } from 'clsx';

export const TONE_OF_VOICE_RESP_LEN_EMOJI = {
  concise: '🎯',
  standard: '⚖️',
  comprehensive: '📙',
};

export const ToneOfVoiceResponseLengthField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch = (() => {}) as (key?: any) => any,
  compact,
}) => {
  const fieldValue = watch(field.key);

  useEffect(() => {
    if (!fieldValue && data) {
      setValue(field.key, data);
      return;
    }

    if (readonly) {
      if (data) {
        setValue(field.key, data);
      } else if (field?.default_value?.value) {
        setValue(field.key, field?.default_value?.value);
      } else {
        setValue(field.key, '');
      }
    }
  }, [readonly, data, field]);

  return field ? (
    <div className={'flex flex-col gap-2.5'}>
      <div>
        <p className={'text-ebony text-sm font-medium'}>Response length</p>
      </div>
      <div>
        {Boolean(field?.options?.length) ? (
          <Controller
            control={control}
            name={field.key}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <ToggleGroup
                className={clsx(
                  'flex gap-1.5 justify-items-stretch items-stretch w-full',
                  readonly && 'pointer-events-none',
                )}
                {...({ onChange } as any)}
                onValueChange={onChange}
                defaultValue={value}
                value={value}
                type="single"
              >
                {field.options.map((option) => {
                  return (
                    <ToggleGroupItem
                      className={'flex flex-1 items-center justify-center'}
                      key={option.key}
                      value={option.value}
                    >
                      {TONE_OF_VOICE_RESP_LEN_EMOJI[option.key]
                        ? `${TONE_OF_VOICE_RESP_LEN_EMOJI[option.key]} ${option.value}`
                        : option.value}
                    </ToggleGroupItem>
                  );
                })}
              </ToggleGroup>
            )}
          />
        ) : null}
      </div>
    </div>
  ) : null;
};
